module.exports = __webpack_public_path__ + "static/media/ppt-icon.078f13b7.svg";